import React from 'react';

import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VerifiedOutlinedIcon from '@mui/icons-material/VerifiedOutlined';

export default function AboutVisionMissionValues(): React.ReactElement {
  return (
    <section className="bg-white">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 sm:px-6 lg:px-12 lg:py-20">
        {/* Top Row - 2 Cards */}
        <div className="grid gap-6 lg:grid-cols-2 lg:gap-8 mb-8">
          {/* Vision Card */}
          <div className="rounded-2xl bg-sky-600 p-8 text-left">
            <div className="flex items-center gap-4">
              <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-white/20 text-white/80">
                <VisibilityOutlinedIcon fontSize="large" />
              </div>
              <h3 className="text-3xl font-semibold text-white/80">Vision</h3>
            </div>
            <p className="mt-5 text-base leading-relaxed text-white/80">
              To provide a total exhibition of industrial technology envisaged in one innovative and
              confident engineering company driven by a true passion to provide intelligent factory answers.
            </p>
          </div>

          {/* Mission Card */}
          <div className="rounded-2xl bg-sky-600 p-8 text-left">
            <div className="flex items-center gap-4">
              <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-white/20 text-white/80">
                <FlagOutlinedIcon fontSize="large" />
              </div>
              <h3 className="text-3xl font-semibold text-white/80">Mission</h3>
            </div>
            <p className="mt-5 text-base leading-relaxed text-white/80">
              To promote value addition in the supply chain while creating employment through
              entrepreneurship, market-focused strategies, and a commitment to excellence in serving customers.
            </p>
          </div>
        </div>

        {/* Bottom Row - 1 Big Card */}
        <div className="rounded-2xl bg-sky-600 p-8 lg:p-12 text-left">
          <div className="flex items-center gap-4">
            <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-white/20 text-white/80">
              <VerifiedOutlinedIcon fontSize="large" />
            </div>
            <h3 className="text-3xl font-semibold text-white/80">Core Values (The Ancient Way)</h3>
          </div>
          <div className="mt-6 flex flex-col gap-6">
            <div>
              <h4 className="text-lg font-semibold text-white/90 mb-2">Service Excellence</h4>
              <p className="text-sm leading-relaxed text-white/80">
                Rapid response and quick delivery are our hallmarks.
              </p>
            </div>
            <div>
              <h4 className="text-lg font-semibold text-white/90 mb-2">Innovation-Led</h4>
              <p className="text-sm leading-relaxed text-white/80">
                We leverage cutting-edge tech—from SCADA systems to advanced thermography—to solve
                complex problems.
              </p>
            </div>
            <div>
              <h4 className="text-lg font-semibold text-white/90 mb-2">Integrity & Professionalism</h4>
              <p className="text-sm leading-relaxed text-white/80">
                We maintain the highest ethical standards in every contract and client interaction.
              </p>
            </div>
            <div>
              <h4 className="text-lg font-semibold text-white/90 mb-2">Long-term Partnerships</h4>
              <p className="text-sm leading-relaxed text-white/80">
                We view ourselves as an extension of your team, building trust through consistent
                performance.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
